var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('v-index',[_c('el-breadcrumb',[_c('el-breadcrumb-item',[_vm._v("教务")]),_c('el-breadcrumb-item',[_c('a',{staticStyle:{"color":"#000000"}},[_vm._v("智能排课")])])],1),_c('v-weburl-iframe',{staticClass:"content",attrs:{"url":"teacher/schedule/setting"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }